import { render, staticRenderFns } from "./CharityCoupons.vue?vue&type=template&id=86ab4f5a"
import script from "./CharityCoupons.vue?vue&type=script&lang=js"
export * from "./CharityCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports